import { render, staticRenderFns } from "./ModeloSLA.vue?vue&type=template&id=73f3542e&"
import script from "./ModeloSLA.vue?vue&type=script&lang=js&"
export * from "./ModeloSLA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports